import React from 'react';

export const Pagination = ({ currentPage, setCurrentPage, totalPages }) => {
  const maxVisiblePages = 4;
  const getPageNumbers = () => {
    let start = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
    let end = start + maxVisiblePages - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(end - maxVisiblePages + 1, 1);
    }

    const pages = [];
    for (let i = start; i <= end; i += 1) {
      pages.push(i);
    }
    return pages;
  };
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  return (
    <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
      <button
        type="button"
        onClick={() => goToPage(currentPage - 1)}
        disabled={currentPage === 1}
        className="bg-white px-3 py-1.5 text-gray-500 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed border-none rounded-l-lg"
      >
        &lt;
      </button>
      <span className="self-stretch w-px bg-gray-300" />
      {getPageNumbers()[0] > 1 && (
        <React.Fragment key="start-ellipsis">
          <button type="button" className="bg-white px-3 py-1.5 border-none text-gray-600 hover:bg-gray-100">
            ...
          </button>
          <span className="self-stretch w-px bg-gray-300" />
        </React.Fragment>
      )}
      {getPageNumbers().map((page) => (
        <React.Fragment key={`page-${page}`}>
          <button
            type="button"
            className={`px-3 py-1.5 border-none text-gray-600 hover:bg-gray-100 ${
              currentPage === page ? 'bg-green-100 text-green-600' : 'bg-white'
            }`}
            onClick={() => goToPage(page)}
          >
            {page}
          </button>
          <span className="self-stretch w-px bg-gray-300" />
        </React.Fragment>
      ))}
      {getPageNumbers().slice(-1)[0] < totalPages && (
        <React.Fragment key="end-ellipsis">
          <button type="button" className="bg-white px-3 py-1.5 border-none text-gray-600 hover:bg-gray-100">
            ...
          </button>
          <span className="self-stretch w-px bg-gray-300" />
        </React.Fragment>
      )}
      <button
        type="button"
        onClick={() => goToPage(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="bg-white px-3 py-1.5 text-gray-500 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed border-none rounded-r-lg"
      >
        &gt;
      </button>
    </div>
  );
};
